module.exports = __webpack_public_path__ + "608a93af633c7fcb25b3eebfcb314bcf.png";